import { render, staticRenderFns } from "./Replicacao.vue?vue&type=template&id=5a8bff1d"
import script from "./Replicacao.vue?vue&type=script&lang=js"
export * from "./Replicacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports